import { SearchFields } from "../../types";

export const BaseUrl = (): string => {
    var result = process.env?.PUBLIC_URL;

    if (result === null || result === "") {
        result = window.location.origin;
    }

    result = window.location.origin;
    return result;
}

export const GetBasename = () => {
    var publicUrl = process.env?.PUBLIC_URL;
    if (publicUrl === null || publicUrl === "") {
        return ""
    }
    
    return GetBasePath(window.location.pathname);
}

export const GetBasePath = (path: string) => {
    var result = path.substr(0, path.lastIndexOf('/'));
    return result;
}

const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
const GRID_PAGE_SIZE = 25;
const SearchFieldsDefaultValue: SearchFields = {
  name: false,
  personnelNumber: false,
};
const MAX_SMALL_SCREEN_SIZE = 767.98;
const MAX_MEDIUM_SCREEN_SIZE = 991.98;
const MAX_LARGE_SCREEN_SIZE = 1199.98;
const MIN_LARGE_SCREEN_SIZE = 992;

export {
  EMPTY_GUID,
  SearchFieldsDefaultValue,
  GRID_PAGE_SIZE,
  MAX_SMALL_SCREEN_SIZE,
  MAX_MEDIUM_SCREEN_SIZE,
  MAX_LARGE_SCREEN_SIZE,
  MIN_LARGE_SCREEN_SIZE,
};
